module.exports = __webpack_public_path__ + "img/icon_command_enter.b137fbf5.svg";